import { useSubscriptionPlans } from 'src/hooks';
import { PaymentPage } from 'src/pages/PaymentBetaPage/PaymentPage';
import { LoadingOverlay } from 'src/pages/PaymentBetaPage/components/LoadingOverlay';

export const PaymentPageWrapper = () => {
  const { isPlansLoadingFirstTime } = useSubscriptionPlans({});

  if (isPlansLoadingFirstTime) {
    return <LoadingOverlay label="Loading plans..." />;
  }
  return <PaymentPage />;
};
